module.exports = __webpack_public_path__ + "static/img/product_images_31_h5_zh.b05ff29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_31_h5_zh.png
// module id = q33z
// module chunks = 34